import React from 'react';
import styled, { css } from 'styled-components';
import useSpecs from '../hooks/use-specs';

const PreviewSpecs = ({
  className,
  iconVariant = false,
  tableVariant = false,
  dashedVariant = false,
  badgeVariant = false,
  ...props
}) => {
  const specs = useSpecs();

  if (iconVariant) {
    return (
      <Grid
        {...props}
        $items={specs.length}
        className={className}
      >
        {specs.map(({ label, icon, value }) => icon && value && (
          <GridItem key={label}>
            <Icon as={icon} />
            <span>{value}</span>
          </GridItem>
        ))}
      </Grid>
    );
  }

  if (badgeVariant) {
    return (
      <Badges
        {...props}
        $items={specs.length}
        className={className}
      >
        {specs.map(({ label, icon, value }) => icon && value && (
          <Badge key={label}>
            <Icon as={icon} />
            <span>{value}</span>
          </Badge>
        ))}
      </Badges>
    );
  }

  if (tableVariant) {
    return (
      <Table
        {...props}
        className={className}
      >
        {specs.map(({ label, value }) => label && value && (
          <Row key={label}>
            <Cel>{label}: </Cel>
            <Cel>{value}</Cel>
          </Row>
        ))}
      </Table>
    );
  }

  if (dashedVariant) {
    return (
      <Dashed
        className={className}
      >
        {specs.map(({ label, value }) => value && (
          <DashedItem key={label}>{value}</DashedItem>
        ))}
      </Dashed>
    );
  }

  return (
    <div
      {...props}
      className={className}
    >
      {specs.map(({ label, value }) => label && value && (
        <div key={label}>
          <span>{label}</span>: <span>{value}</span>
        </div>
      ))}
    </div>
  );
};

export const Icon = styled.svg``;

export const GridItem = styled.div``;

export const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
`;

export const Badge = styled.div`
  background-color: ${({ theme }) => theme.primaryColor}1A;
  color: ${({ theme }) => theme.primaryColor};
  display: flex;
  gap: .25rem;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: .25rem .5rem;
  font-size: .75rem;

  ${Icon} {
    width: 1rem;
    height: 1rem;
  }
`;

export const DashedItem = styled.span``;

const Grid = styled.div`
  display: grid;

  ${({ $items }) => css`
    grid-template-columns: repeat(${$items}, 1fr);
  `}
`;

const Cel = styled.div`
  display: inline;
  flex: 1;
`;

const Row = styled.div`
  display: flex;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: grid;
    grid-template-columns: 5rem 1fr;
  }
`;

const Table = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: .5rem .25rem;
  grid-template-columns: 1fr;
  margin-bottom: 1rem;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    margin-bottom: 0;
    grid-template-columns: 1fr 1fr;
  }
`;

const Dashed = styled.div`
  ${DashedItem}:not(:last-child) {
    &::after {
      content: " | ";
    }
  }
`;

export default styled(PreviewSpecs)``;
